module.exports = __webpack_public_path__ + "static/img/14TA700G.5a182c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/sport/04sportDesc/14TA700G.png
// module id = z24V
// module chunks = 0